module.exports = __webpack_public_path__ + "media/images/placeholders/entity_placeholder-1a5e863e772012e46a26e971017422d5.png";